import React from "react";
// import { ReactComponent as ArrowUpDown } from "../../../assets/unfold_more_black_24dp.svg";
import "./styles.scss";
const DropDownDisabled = ({
  children,
  obrigatorio,
  nomeDropDown,
  largura,
  margin,
}) => {
  return (
    <div
      className="dropDownDisabled"
      style={{
        width: largura || "351px",
        margin: margin || "25px",
      }}
    >
      <label className="dropDownDisabled__title">{nomeDropDown}</label>
      <button className="dropDownDisabled__button">{children}</button>
      {obrigatorio && (
        <label className="dropDownDisabled__obrigatorio">
          Campo obrigatório
        </label>
      )}
      {/* <ArrowUpDown className="dropDownDisabled__arrow" /> */}
    </div>
  );
};

export default DropDownDisabled;
